import { ssnRegex } from '@cof/fs-ssn-field-core-beta';
export const tooShortValidatorSsn = {
    key: 'tooShort',
    message: 'Please enter a valid social security number.',
    isValid(instance, value) {
        const validLength = instance.useMaskedValue ? 11 : 9;
        if (value && value.length < validLength) {
            return false;
        }
        return true;
    }
};
export const tooLongValidatorSsn = {
    key: 'tooLong',
    message: 'Please enter a valid social security number.',
    isValid(instance, value) {
        const validLength = instance.useMaskedValue ? 11 : 9;
        if (value && value.length > validLength) {
            return false;
        }
        return true;
    }
};
export const patternValidatorSsn = {
    attribute: 'dangerously-disable-pattern-validation',
    key: 'patternMismatch',
    message: 'Please enter a valid social security number',
    isValid(instance) {
        if (!instance.manager || instance.dangerouslyDisablePatternValidation) {
            return true;
        }
        if (!instance.manager?.formattedValue) {
            return true;
        }
        return !!ssnRegex.exec(instance.manager.formattedValue);
    }
};
//# sourceMappingURL=validators.js.map